import styled from "styled-components";

export const Button = styled.button`
  background-color: #cbcbcb;
  color: #535559;
  width: 280px;
  min-width: 160px;
  border: none;
  border-radius: 15px;
  padding: 10px 20px;
  font-family: "Inter";
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;

  &:hover,
  &:focus,
  &:active {
    background-color: #ff5837;
    color: #fff;
  }
`;